import React, { createContext, useState, useContext, ReactNode } from 'react';

interface SessionContextType {
  isSessionKilled: boolean;
  killedBy: string;
  setSessionKilled: (isKilled: boolean, killedBy?: string) => void;
  handleSessionRelogin: () => void;
}

export const SessionContext = createContext<SessionContextType>({
  isSessionKilled: false,
  killedBy: '',
  setSessionKilled: () => {},
  handleSessionRelogin: () => {},
});

interface SessionProviderProps {
  children: ReactNode;
}

export const SessionProvider: React.FC<SessionProviderProps> = ({ children }) => {
  const [isSessionKilled, setIsSessionKilled] = useState(false);
  const [killedBy, setKilledBy] = useState('');

  const setSessionKilled = (isKilled: boolean, killedBy: string = 'Administrator') => {
    setIsSessionKilled(isKilled);
    setKilledBy(killedBy);
  };

  const handleSessionRelogin = () => {
    setIsSessionKilled(false);
    setKilledBy('');
    
    // Redirect to login page
    window.location.replace("/");
  };

  return (
    <SessionContext.Provider 
      value={{ 
        isSessionKilled, 
        killedBy, 
        setSessionKilled, 
        handleSessionRelogin 
      }}
    >
      {children}
    </SessionContext.Provider>
  );
};

// Custom hook for using the session context
export const useSession = () => useContext(SessionContext); 